import {IdType} from 'ts/IdType';

export enum TopUpTransactionStatusType {
    FAILED = 'FAILED',
    COMPLETED = 'COMPLETED',
}

export interface PartnerBalanceTransaction {
    id?: IdType;
    transaction_type?:
        | "ORDER"
        | "BALANCE_TRANSFER"
        | "TOP_UP"
        | "EXPIRY_REFUND"
        | "CANCELLED_CARD_REFUND"
        | "ADJUSTMENT"
        | null;
    transaction_status: TopUpTransactionStatusType;
    transferred_by?: string;
    partner?: string;
    partner_id?: IdType;
    partner_name?: string;
    used_currency: string;
    original_currency?: string;
    amount: number;
    denomination?: number;
    created_at?: string;
    date?: string;
    time?: string;
    running_balance: number;
}
